import dayjs, { Dayjs } from 'dayjs';
import { ValueOption } from 'types/common';

export const KNOWN_DATE_FORMATS = [
  'DD-MM-YYYY',
  'DD/MM/YYYY',
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  'MM-DD-YYYY',
  'MM/DD/YYYY',
  'YYYY-MM-DDTHH:mm:ssZ',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
];

export const DATE_FORMATS = {
  DISPLAY: 'DD-MM-YYYY',
  API: 'YYYY-MM-DD',
  FULL: 'YYYY-MM-DDTHH:mm:ssZ',
  SHORT_MONTH: 'DD-MMM-YYYY',
  MMM_DD_YYYY: 'MMM DD, YYYY',
};

export const CHART_COLORS = [
  {
    light: '#C4EED0',
    dark: '#009D2D',
  },
  {
    light: '#FEB2C2',
    dark: '#FC6585',
  },
  {
    light: '#D1DBFF',
    dark: '#6586FC',
  },
  {
    light: '#FFD9B1',
    dark: '#FCB365',
  },
];

export const DEFAULT_DATERANGE_FILTER = {
  from: dayjs().subtract(7, 'day').startOf('day').format(DATE_FORMATS.API),
  to: dayjs().subtract(1, 'day').endOf('day').format(DATE_FORMATS.API),
};

export const DATE_FILTER_OPTIONS = [
  {
    label: 'Last 7 days',
    id: 1,
    get: (): [Dayjs, Dayjs] => [
      dayjs().subtract(7, 'day').startOf('day'),
      dayjs().subtract(1, 'day').endOf('day'),
    ],
    isReadOnly: true,
  },
  {
    label: 'Last 30 days',
    id: 2,
    get: (): [Dayjs, Dayjs] => [
      dayjs().subtract(30, 'day').startOf('day'),
      dayjs().subtract(1, 'day').endOf('day'),
    ],
    isReadOnly: true,
  },
  {
    label: 'This month',
    id: 3,
    get: (): [Dayjs | null, Dayjs | null] => [dayjs().startOf('month'), dayjs()],
    isReadOnly: true,
  },
  {
    label: 'Last month',
    id: 4,
    get: (): [Dayjs | null, Dayjs | null] => [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().subtract(1, 'month').endOf('month'),
    ],
    isReadOnly: true,
  },
  {
    label: 'Custom',
    id: 5,
    get: (): [Dayjs | null, Dayjs | null] => [null, null],
    isReadOnly: false,
  },
];

export const MONTH_OPTIONS: ValueOption[] = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const IMAGE_TYPES = {
  allowedTypes: [
    'image/jpeg', // .jpg, .jpeg
    'image/png', // .png
    'image/webp', // .webp
  ],
  displayFormats: ['JPEG', 'PNG', 'WEBP'],
};

export const PDF_TYPES = {
  allowedTypes: ['application/pdf'],
  displayFormats: ['PDF'],
};

export const EXCEL_TYPES = {
  allowedTypes: [
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    'text/csv', // .csv
  ],
  displayFormats: ['xls', 'xlsx', 'csv'],
};

export const MODULE_KEYS = {
  analytics: 'analytics',
  analytics_overview: 'analytics_overview',
  analytics_pages_screens: 'analytics_pages_screens',
  analytics_user_engagements: 'analytics_user_engagements',

  user: 'user',

  project_details: 'project_details',
  project_details_projects: 'project_details_projects',
  project_details_clusters: 'project_details_clusters',
  project_details_towers: 'project_details_towers',
  project_details_units: 'project_details_units',

  project_updates: 'project_updates',

  content: 'content',

  help_and_support: 'help_and_support',

  admin: 'admin',
};
